import { useGetPublicStrukturOrganisasiChart } from '@tatatemplate/shared-lib'

export function useOrgChart() {
  return useGetPublicStrukturOrganisasiChart({
    query: {
      queryKey: ['org-chart'],
      select: (res) => res.data,
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  })
}
